
import { InputFilter } from './opacc.class.filter-input.js';
import { SelectFilter } from './opacc.class.filter-select.js';
import { RangeFilter } from './opacc.class.filter-range.js';
import { DatePickerFilter } from './opacc.class.filter-datepicker.js';

/** @module filter */

/**
 * Basisklasse für das Modul "Filter".
 * @param {Object} [opaccFilterCriterias]
 */
export class OpaccFilter {
	constructor(opaccFilterCriterias) {
		this.opaccFilterCriterias = opaccFilterCriterias;
		this.filterObjects = [];
		this.wrapperElement = document.querySelector('.content');
		this.setToggleButtonVisibility();
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		this.toggleFilterItem();
		this.searchFilterValue();
	}

	/**
	 *
	 *
	 */
	toggleFilterItem() {
		this.wrapperElement.addEventListener('click', e => {
			let filterWrapper =  this.wrapperElement.querySelectorAll('.filter-set-list');
			if (filterWrapper.length > 0) {
				let listSelector = e.target.closest('.filter-body-inner');
				let filterSearchContentSelector = e.target.closest('.filter-body-search');
				let filterSetList = e.target.closest('.filter-head');
				let filterElem = e.target.closest('.opc-filter');

				let filterTagList = e.target.closest('.filter-set-selection');

				// close open-Filter
				let filterToggleMobile = this.wrapperElement.querySelectorAll('.filter-toggle');
				// check if is Mobile-view and toggle filter-list
				Array.from(filterToggleMobile).forEach(filterToggle => {
					if (e.target === filterToggle) {
						e.target.closest('.opc-filter-set').querySelector('.filter-set-list').classList.toggle('is-open');
					}
				});

				// close all Open Filter
				let currentOpenFilterElem = this.wrapperElement.querySelector('.opc-filter.is-open[data-op-style="dropdown"]');
				if (currentOpenFilterElem && !filterSearchContentSelector && !listSelector) {
					currentOpenFilterElem.classList.remove('is-open');
					currentOpenFilterElem.classList.remove('has-focus');
				}
				let allOpenFilterElems = this.wrapperElement.querySelectorAll('.opc-filter.is-open[data-op-style="dropdown"]');

				// Filter-Click-Event
				if (filterElem) {
					if (filterSetList) {
						//check if Filter is Dropdown-Filter
						let filterItem = filterSetList.closest('.opc-filter[data-op-style="dropdown"]');
						if (filterItem) {
							// Open filter if clicked Filter != previously closed Filter
							if (filterItem != currentOpenFilterElem) {
								// close all other Filters
								Array.from(allOpenFilterElems).forEach(item => {
									item.classList.remove('is-open');
									item.classList.remove('has-focus');
								});

								filterItem.classList.add('is-open');
							}
						}
					}

					let isRangeFilter = (filterElem.dataset.opType === 'range') ? true : false;
					let isDatePickerFilter = (filterElem.dataset.opType === 'datepicker') ? true : false;
					let isAsyncSelect = (this.opaccFilterCriterias.isSelectionFilterAsyncDataload(filterElem.dataset.opAsync));
					if (!this.filterObjects[filterElem.id] ||
						(isRangeFilter && !filterElem.classList.contains('js-init')) ||
						(isDatePickerFilter && !filterElem.classList.contains('js-init')) ||
						(isAsyncSelect && !filterElem.classList.contains('js-init'))) {
						let filterObj = undefined;
						switch (filterElem.dataset.opType) {
						case 'text':
							filterObj = new InputFilter(filterElem, this.wrapperElement, this.opaccFilterCriterias);
							break;
						case 'range':
							filterObj = new RangeFilter(filterElem, this.wrapperElement, this.opaccFilterCriterias);
							filterElem.classList.add('js-init');
							break;
						case 'datepicker':
							filterObj = new DatePickerFilter(filterElem, this.wrapperElement, this.opaccFilterCriterias);
							filterElem.classList.add('js-init');
							break;
							default:
							filterObj = new SelectFilter(filterElem, this.wrapperElement, this.opaccFilterCriterias);
							filterElem.classList.add('js-init');
							break;
						}
						this.filterObjects[filterElem.id] = filterObj;
					}

					// Set focus on Search-Input
					let searchInputField = filterElem.querySelector('.filter-body-search > input');
					if (searchInputField && filterElem.classList.contains('is-open') && !filterElem.classList.contains('has-focus')) {
						searchInputField.focus();
						// set cursor at end of Text
						let val = searchInputField.value;
						searchInputField.value = '';
						searchInputField.value = val;
						filterElem.classList.add('has-focus');
					}

					// Set focus on Input by RangeFilter
					let rangeInputField = filterElem.querySelector('.slider-values > input[type="text"]');
					if (rangeInputField && filterElem.classList.contains('is-open') && !filterElem.classList.contains('has-focus')) {
						rangeInputField.focus();
						// set cursor at end of Text
						let val = rangeInputField.value;
						rangeInputField.value = '';
						rangeInputField.value = val;
						filterElem.classList.add('has-focus');
					}

					// Select Item or Search within Filter
					if (listSelector || filterSearchContentSelector) {
						if (e.target.matches('label')) {
							this.filterObjects[filterElem.id].selectValueByTargetAndSetFilterCriterias(e.target);
						}
						else if (e.target.matches('span.filteritemamount, span.item-marker')) {
							this.filterObjects[filterElem.id].selectValueByTargetAndSetFilterCriterias(e.target.parentElement);
						}
					}
				}
				// Deselect Filter by Tag-List
				if (filterTagList || filterElem) {
					if (e.target.matches('.tag-remove')) {
						this.opaccFilterCriterias.remove(e.target.dataset.opFilterattr, e.target.dataset.opItemvalue, true, e.target.closest('.filter-set-selection').dataset.opGroupid, e.target.dataset.opFilterid);
					}
				}
				if (e.target.matches('.filter-reset')) {
					let initFilter = e.target.dataset.opInit;
					let groupId = e.target.dataset.opGroupid;
					let filterId = null;

					if (!groupId) {
						let filter = e.target.closest('.opc-filter');
						if (filter) {
							groupId = filter.dataset.opGroupid;
							filterId = e.target.dataset.opFilterid;
						}
					}
					this.opaccFilterCriterias.remove(e.target.dataset.opFilterattr, null, true, groupId, filterId, initFilter, !groupId);
				}
			}
		}, false);
	}

	/**
	 *
	 *
	 */
	searchFilterValue() {
		this.wrapperElement.addEventListener('keyup', e => {
			let filterWrapper = e.target.closest('.opc-filter');
			if (filterWrapper) {
				if (e.target.matches('.op-form-input') || e.target.matches('.opc-input'))
				{
					// Liste der Filterwerte durchsuchen
					let list = filterWrapper.querySelector('.select-list');
					if (list)
					{
						let searchString = e.target.value.toLowerCase();
						Array.from(list.children).forEach(i => {

							let item = i.querySelector('input');
							if (item.nextElementSibling.innerText.toLowerCase().indexOf(searchString) < 0)
							{
								i.style.display = 'none';
							}
							else
							{
								!item.checked ? i.style.display = 'block': i.style.display = 'inherit';
							}
						});
					}
					// Input-Filter abfragen (bei Enter-Taste)
					else if (e.keyCode === 13)
					{
						// alle Inputfilter innerhalb des Filtersets ermitteln und alle Inputfilter aufbereiten für AjaxRequest
						let inputFilterElems = this.opaccFilterCriterias.prepareFilterCriterias(filterWrapper);
						Array.from(inputFilterElems).forEach((item, idx) => {
							let sendRequest = false;
							if (idx === inputFilterElems.length-1) {
								sendRequest = true;
							}
							this.opaccFilterCriterias.change(item.dataset.opFilterattr, item.value, sendRequest, item.closest('.opc-filter').dataset.opGroupid, item.closest('.opc-filter').id);
						});
					}
				}
			}
		});
	}

	/**
	 * Methode prüft ob Filterelemente vorhanden sind. Falls nicht, wird die class is-hidden auf den toggle-button
	 * gesetzt, damit dieser dynamisch ausgeblendet werden kann.
	 */
	setToggleButtonVisibility() {
		let filterWrapper = this.wrapperElement.querySelectorAll('.opc-filter-set');
		if (filterWrapper.length > 0) {
			Array.from(filterWrapper).forEach(elem => {
				let filterLists = elem.querySelector('.filter-set-list');
				if (filterLists && filterLists.children.length) {
					return;
				}

				let filterToggle = elem.querySelector('.filter-toggle');
				if (filterToggle) {
					filterToggle.classList.add('is-hidden');
				}

			})
		}
	}
}